/** AUTO GENERATED FROM "node ./src/utils/convert-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg width="69.86" height="95.58" viewBox="0 0 69.86 95.58" fill="currentColor" className={classNames('nmx-icon', className)} ref={svgRef} {...otherProps}>
        <defs>
          <mask id="bed50537-5790-4399-afe8-33ce6f71b44e" x="0" y="0" width="69.86" height="95.58" maskUnits="userSpaceOnUse">
            <g transform="translate(-42.5 -29.5)">
              <polygon points="42.5 125.08 112.36 125.08 112.36 29.5 42.5 29.5 42.5 125.08" fill="#fff" fillRule="evenodd"/>
            </g>
          </mask>
        </defs>
        <path d="M100.67,64.43A23.24,23.24,0,1,1,77.43,41.19a23.23,23.23,0,0,1,23.24,23.24" transform="translate(-42.5 -29.5)" fill="#ffb81c" fillRule="evenodd"/><path d="M77.43,29.5A34.93,34.93,0,0,0,42.5,64.43a43,43,0,0,0,2.12,12.75c2.75,8.83,8,18.21,15,27.75a176.79,176.79,0,0,0,11.66,14.23l.92,1,.44.48.87.92.42.45.81.84.86.88,1,1a1.25,1.25,0,0,0,1.74,0l.58-.58.65-.65.64-.65L81,122l.85-.9.88-1,.91-1a176.79,176.79,0,0,0,11.66-14.23c7-9.54,12.21-18.92,15-27.75a43,43,0,0,0,2.12-12.75A34.93,34.93,0,0,0,77.43,29.5Zm0,2.5a32.43,32.43,0,0,1,32.43,32.43,40.55,40.55,0,0,1-2,12c-2.66,8.53-7.76,17.67-14.6,27a171.44,171.44,0,0,1-11.49,14l-.9,1-.44.48-.85.9-.82.86-.78.81-.55.56-.55-.56-.78-.81-.82-.86-.85-.9-.44-.48-.9-1a173.53,173.53,0,0,1-11.49-14C54.76,94.11,49.66,85,47,76.44a40.58,40.58,0,0,1-2-12A32.43,32.43,0,0,1,77.43,32Z" transform="translate(-42.5 -29.5)" fill="#0e497b"/><g mask="url(#bed50537-5790-4399-afe8-33ce6f71b44e)">
          <path d="M73.81,54.52h6.31V49.25H73.81Zm6.52,20.92h3.41v3.62H71.12V75.44h3.41V62H71.12V58.25h9.21Z" transform="translate(-42.5 -29.5)" fill="#fefefe" fillRule="evenodd"/>
        </g>
      </svg>

    );
  }
}

Icon.displayName = 'MapPinInformationalIcon';

export default Icon;
